import axiosInstance from "../services/AxiosInstance";

export function getAudiencesApi({ page, search, limit }) {
  return axiosInstance.get(
    `audience?page=${page}&search=${search}&limit=${limit}`
  );
}

export function createAudienceApi(data) {
  return axiosInstance.post(`audience`, { ...data, dashboardreg: true });
}

export function updateAudienceApi(data, id) {
  return axiosInstance.put(`audience/${id}`, data);
}

export function deleteAudienceApi(id) {
  return axiosInstance.delete(`audience/${id}`);
}

export function addGuestsApi(data) {
  return axiosInstance.post(`audience/add-guest`, data);
}

export function sendQRPassToGuestWhatsAppApi(data) {
  return axiosInstance.post(`audience/send-qr-pass-to-guest-whatsapp`, data);
}

// export function formatPosts(postsData) {
//   let posts = [];
//   for (let key in postsData) {
//     posts.push({ ...postsData[key], id: key });
//   }

//   return posts;
// }
